// Functions relating to the Payment UI

/*****************************************************************************************************************************

	this is pretty confusing - there are 2 of these - payment.js and paymentSingleProduct.js - which one is applied is set by 
	the value of globals.isSingleProductPage 
*/

$(function() {

	if (globals.isSingleProductPage)
		return;

    $('.product-selector').on('change', function (e) {
    	getProductSelections();
    });

    $('#vat_jurisdiction').on('change', function(e) {
        getProductSelections();
    });

    // Do we have a query string?
    if (getParameterByName('standard') !== null) {
    	$('#standard_bundle').val(getParameterByName('standard'));
    }
    if (getParameterByName('pro') !== null) {
    	$('#pro_bundle').val(getParameterByName('pro'));
    }
    getProductSelections();

    $('#discount_code').on('change', function(e) {
        e.preventDefault();
        var discount_code = $('#discount_code').val();
        verify_discount_code(discount_code);
    });


    var discountApplied = false;
    var discountAmount = 0;
    var discountType = 'flat';

    function verify_discount_code(discount_code) {
        var uri = '/discount/verify?code=' + discount_code;
        var jqxhr = $.get( uri, function(data) {
            if (data !== false) {
                apply_discount_code(data);
            } else {
                $('#discount_code').val('');
                $('#discountCodeMessage').addClass('error').html('Sorry that code is not valid.');
            }
        }).fail(function() {
            $('#discount_code').val('');
            $('#discountCodeMessage').addClass('error').html('Sorry that code is not valid.');
        });
    }

    function apply_discount_code(code) {
        if (discountApplied === false) {
            discountType = code.type;
            discountAmount = code.discount;
            discountApplied = true;
            $('#discount_applied').show(0);
            getProductSelections();
        }
    }

    function getParameterByName(name) {
        url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }


    function getProductSelections() {
        var stdProductId = $('#standard_bundle').val();
        var proProductId = $('#pro_bundle').val();
        
        var stdProduct = false;
        var proProduct = false;

        if (stdProductId !== '') {
            stdProduct = $.grep(globals.stdProducts, function(e){ return e.id == stdProductId; });
        }

        if (proProductId !== '') {
            proProduct = $.grep(globals.proProducts, function(e){ return e.id == proProductId; });
        }

        updateTotal(stdProduct[0], proProduct[0]);

    }

    function updateTotal(stdProduct, proProduct) {

        var stdLabel = 'No Standard plan selected';
        var stdCredits = 0;
        var stdPrice = 0;

        var proLabel = 'No Pro bundle selected';
        var proCredits = 0;
        var proPrice = 0;

        var subtotal = 0.00;
        var totalDiscount = 0;
        var discountRate = '0%';

        var taxRate = 0;
        var totalTax = 0;
        var totalPrice = 0;

        if (stdProduct) {
            stdLabel = stdProduct.name;
            stdCredits = stdProduct.credits;
            stdPrice = stdProduct.price / 100;
        }

        if (proProduct) {
            proLabel = proProduct.name;
            proCredits = proProduct.credits;
            proPrice = proProduct.price / 100;
        }

        // Get the VAT rate
        var jurisdiction_id = $('#vat_jurisdiction').val();
        taxRate = $.grep(globals.vatRates, function(e){ return e.jurisdiction_id == jurisdiction_id; });
        if (taxRate.length > 0) {
            taxRate = taxRate[0].rate / 100;
        } else {
            taxRate = 0;    
        }

        subtotal = stdPrice + proPrice;

        // discount code
        if (discountType == 'flat') {
            discountRate = '&pound;' + discountAmount;
            totalDiscount = discountAmount;
        } else if (discountType == 'percentage') {
            discountRate = discountAmount + '%';
            totalDiscount = subtotal * (discountAmount / 100);
        }

        if (totalDiscount < 0) {
            totalDiscount = 0;
        }
        
        // Total it up
        subtotal = subtotal - totalDiscount;
        totalTax = subtotal * taxRate;
        totalPrice = subtotal + totalTax;

        // Format up
        stdPrice = parseFloat(stdPrice).toFixed(2);
        proPrice = parseFloat(proPrice).toFixed(2);
        subtotal = parseFloat(subtotal).toFixed(2);
        totalTax = parseFloat(totalTax).toFixed(2);
        totalPrice = parseFloat(totalPrice).toFixed(2);

        // Set the fields
        $('.stdLabel').html(stdLabel);
        $('.stdCredits').html(stdCredits);
        $('.stdPrice').html('&pound;' + stdPrice);

        $('.proLabel').html(proLabel);
        $('.proCredits').html(proCredits);
        $('.proPrice').html('&pound;' + proPrice);

        $('.total_discount').html('&pound;' + totalDiscount);
        $('#discountRate').html(discountRate);

        $('.subtotal').html('&pound;' + subtotal);
        $('.total_tax').html('&pound;' + totalTax + ' (' + taxRate * 100 + '%)');
        $('.total_price').html('&pound;' + totalPrice);

    }
});
